// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IHealthPlanTypePropertyDto
 */
export interface IHealthPlanTypePropertyDto {
    /**
     * 
     * @type {Set<string>}
     * @memberof IHealthPlanTypePropertyDto
     */
    health_plan_types?: Set<IHealthPlanTypePropertyDtoHealthPlanTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanTypePropertyDto
     */
    health_plan_type_state?: IHealthPlanTypePropertyDtoHealthPlanTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IHealthPlanTypePropertyDtoHealthPlanTypesEnum {
    MEDICAL = 'MEDICAL',
    RX = 'RX',
    DENTAL = 'DENTAL',
    VISION = 'VISION'
}
/**
* @export
* @enum {string}
*/
export enum IHealthPlanTypePropertyDtoHealthPlanTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IHealthPlanTypePropertyDto interface.
 */
export function instanceOfIHealthPlanTypePropertyDto(value: object): value is IHealthPlanTypePropertyDto {
    return true;
}

export function IHealthPlanTypePropertyDtoFromJSON(json: any): IHealthPlanTypePropertyDto {
    return IHealthPlanTypePropertyDtoFromJSONTyped(json, false);
}

export function IHealthPlanTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'health_plan_types': json['health_plan_types'] == null ? undefined : new Set(json['health_plan_types']),
        'health_plan_type_state': json['health_plan_type_state'] == null ? undefined : json['health_plan_type_state'],
    };
}

export function IHealthPlanTypePropertyDtoToJSON(json: any): IHealthPlanTypePropertyDto {
    return IHealthPlanTypePropertyDtoToJSONTyped(json, false);
}

export function IHealthPlanTypePropertyDtoToJSONTyped(value?: IHealthPlanTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'health_plan_types': value['health_plan_types'] == null ? undefined : Array.from(value['health_plan_types'] as Set<any>),
        'health_plan_type_state': value['health_plan_type_state'],
    };
}

